import keys from './keys';
import api from './api';
import roles from './roles';

export const KEYS = { ...keys };
export const API = { ...api };
export const ROLES = { ...roles };